import React from 'react';
import {ExpandToggle} from '@components/util/ExpandToggle';
import {CommentSectionMini} from '@components/call-card/CommentSectionMini';
import {List, Map, Set} from 'immutable';
import {User, UserId} from 'records/User';
import {UserComment} from 'records/UserComment';
import {CommentSectionFull} from '@components/call-card/CommentSectionFull';
import {PlayerProps} from '@components/call-card/Player.utils';
import {CallAsset, DragStatus} from '@store/call-card/CallCard.types';
import {Call} from '@store/call-card/Call';
import {SetState} from '@store/@types/util/React';
import {Seconds} from '@store/@types/util';

interface CommentSectionProps extends PlayerProps {
  comments: Map<UserId, List<UserComment>>;
  sessionUser: User;
  call: Call;
  callAsset: CallAsset | undefined;
  dragStatus: DragStatus;
  newComment: UserComment | undefined;
  setNewComment: SetState<UserComment | undefined>;
  directReports: Set<UserId>;
  setTimeSeconds: (seconds: Seconds) => void;
  playRecording: () => void;
}

export const CommentSection: React.FC<CommentSectionProps> = props => {
  return (
    <div className="comment-section">
      <ExpandToggle
        expanded={<CommentSectionFull {...props} />}
        minimized={<CommentSectionMini {...props} callId={props.call.id} />}
      />
    </div>
  );
};
